module.exports = __webpack_public_path__ + "static/media/carousel-1.8dda9a92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel-1.jpg
// module id = 146
// module chunks = 1